import React from 'react';
import Dufflesdata from '../Data/Dufflesdata'
import { Itemcard } from '../Components/Itemcard/Itemcard';


export const Backpacks = () => {
  return (
    <div>
      <section className=' container'>
        <div className='row justify-content-center'>
          {Dufflesdata.productData.map((item, index) => {
            return (
              <Itemcard
                img={item.img}
                title={item.title}
                price={item.price}
                desc={item.desc}
                star1={item.star1}
                star2={item.star2}
                star3={item.star3}
                star4={item.star4}
                star5={item.star5}
                oldprice={item.oldprice}
                item={item}
                key={index} />
            )
          })}
        </div>
      </section>
    </div>
  )
}
